export default "__VITE_ASSET__CywKZHux__"